import UserCard from '@components/cards/UserCard';
import algolia from '@integrations/Algolia';
import Sentry from '@integrations/Sentry';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import { useStyles } from '@ui/utils/makeStyles';
import getPlatform from '@utils/getPlatform';
import makeFacetFilters from '@utils/makeFacetFilters';
import makeIndexName from '@utils/makeIndexName';
import { userToSegmentEventData } from '@utils/segmentAnalytics';
import { GetServerSideProps } from 'next';
import React from 'react';

const index = algolia.initIndex(makeIndexName('makers'));

export const getServerSideProps: GetServerSideProps = async () => {
  const currentPlatform = getPlatform();
  const searchResults = await index.search('', {
    hitsPerPage: 1000,
    facetFilters: makeFacetFilters({
      published: 'true',
    }),
    analyticsTags: [currentPlatform],
  });
  const data = {
    makers: JSON.stringify(searchResults.hits),
  };

  return { props: { data } };
};

function Makers(props) {
  const { theme } = useStyles();
  const makers = JSON.parse(props.data.makers) as guesthouse.User[];

  return (
    <ContentBlock>
      <Grid
        container
        spacing={4}
      >
        {makers.map((maker, i) => {
          return (
            <Grid
              key={`${i}:${maker.docID}`}
              item
              xs={6}
              md={4}
              lg={2}
              xl={2}
            >
              <UserCard
                key={maker.docID}
                user={maker}
                style={{ marginBottom: theme.spacing(8) }}
                onClick={() => {
                  try {
                    window.analytics?.track('Maker Clicked', userToSegmentEventData(maker));
                  } catch (e) {
                    Sentry.captureException(e);
                  }
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </ContentBlock>
  );
}


export default Makers;
